export default (ore = 0) => {
    const kroner = Math.floor(ore) / 100;

    const formattedKroner = kroner
        .toFixed(2)
        .replace('.', ',')
        .replace(',00', '');

    return `${formattedKroner} kr`;
};



// WEBPACK FOOTER //
// ./lib/formatOreToKroner.js